// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-core%2Fsrc%2Fevents.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------

import { IEvent, IUserCommand } from '../events';
import { SchemaObject } from './schema-object.g';
import { ISchemaObject, SchemaObjectHeader } from '../schema-object';

export class Event implements IEvent {
    public timestamp: number;
    public type: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IEvent) {
        SchemaObject.assign(Event, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_Event';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: Event.getTypeName(), B_: Event.getBaseTypes() };
    /**
     * Checks if passed schema object is of Event type or its inheritor and implements {@link IEvent}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IEvent {
        return SchemaObject.matchesTypesFor(schemaObject, [Event.getTypeName()]);
    }
}

export class UserCommand implements IUserCommand {
    public durationMs: number;
    public controlId?: string;
    public extendedMetadata?: ISchemaObject;
    public timestamp: number;
    public type: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IUserCommand) {
        SchemaObject.assign(UserCommand, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Core_UserCommand';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_Event'];
    }
    public static readonly H_ = { T_: UserCommand.getTypeName(), B_: UserCommand.getBaseTypes() };
    /**
     * Checks if passed schema object is of UserCommand type or its inheritor and implements {@link IUserCommand}
     */
    public static typeGuard(schemaObject: ISchemaObject): schemaObject is IUserCommand {
        return SchemaObject.matchesTypesFor(schemaObject, [UserCommand.getTypeName()]);
    }
}

